const bookingStatuses = {
    confirmed: {
        chipType: 'warning'
    },
    requested: {
        chipType: 'warning'
    },
    purchased: {
        chipType: 'success'
    },
    canceled: {
        chipType: 'danger'
    }
};

Object.keys(bookingStatuses).forEach(key => {
    bookingStatuses[key].key = key;
});

export default bookingStatuses;
